import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row } from 'react-bootstrap';
import { capitalizeFirstLetter, CharacterCount } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";

const StepFive = ({ handleNext, handleBack, storedData, stepNum, jobType }) => {

    const defaultState = {
        adjusmentWhenAttendingInterview: '',
        otherInformation: '',
        cvFile: null
    };

    const [formData, setFormData] = useState(defaultState);

    const handleEventChange = (event, keyName) => {
        setFormData({
            ...formData,
            [keyName]: event
        });
    };

    const handleRemoveFile = () => {
        setFormData({
            ...formData,
            cvFile: null
        });
    };


    function handleFileUpload(event) {
        const newFile = event.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5 MB

        if (newFile && newFile.size > maxSize) {
            alert("File size is too large. Maximum file size allowed is 5MB.");
            event.target.value = null; // clear the file input
            return;
        }

        const reader = new FileReader();

        reader.onload = function (event) {
            const base64String = btoa(
                new Uint8Array(event.target.result)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            const documentFilename = newFile.name;
            setFormData({
                ...formData,
                cvFile: {
                    Base64: base64String,
                    DocumentFilename: documentFilename
                }
            });
        };

        reader.readAsArrayBuffer(newFile);
    }



    // ## HOOKS ##
    useEffect(() => {
        if (!isEmpty(storedData)) {
            setFormData(storedData);

            console.log(storedData);
        }
    }, []);

    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >{stepNum} Any Other Information</h2>
            </Col>
            <Col sm={12} md={12}>
                <Form.Group>
                    <div style={{ marginBottom: '10px' }}>


                        <Form.Label style={{ textAlign: 'left' }}>
                            Please include details explaining gaps in your employment history, skills which you have developed outside of work and the reason(s) why you feel you would be suitable for the position.
                        </Form.Label>

                    </div>
                    <Form.Control className="custom-input" as="textarea" rows={7}
                        onChange={(e) => handleEventChange(e.target.value, "otherInformation")} value={formData.otherInformation}
                        maxLength="1500" style={{ height: 'auto', marginBottom: '2px' }} />
                    <CharacterCount count={formData.otherInformation ? formData.otherInformation.length : 0} maxCount={1500} />
                </Form.Group>
            </Col>
            <Col sm={12} md={12}>
                <Form.Group>
                    <div style={{ marginBottom: '10px' }}>
                        <Form.Label style={{ textAlign: 'left' }}>
                            Do you require any reasonable adjustments as part of the recruitment process, including when attending an interview or
                            participating in aptitude tests? If yes, please give details:
                        </Form.Label>
                    </div>
                    <Form.Control className="custom-input" as="textarea" rows={3}
                        onChange={(e) => handleEventChange(e.target.value, "adjusmentWhenAttendingInterview")}
                        value={formData.adjusmentWhenAttendingInterview} maxLength="500"
                        style={{ height: 'auto', marginBottom: '2px' }} />
                </Form.Group>
            </Col>

            <Col md={12}>
                <h5>CV Upload (Optional):</h5>
                <div className="file-upload-container">
                    <label htmlFor="file-upload" className="file-upload-label">
                        <i className="fas fa-cloud-upload-alt file-upload-icon"></i>
                        {formData.cvFile?.DocumentFilename ? (
                            <>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {formData.cvFile?.DocumentFilename}

                                    <Button onClick={() => handleRemoveFile()} style={{ marginLeft: '-8px' }} className="btn-link btn-xs" href="#pablo" variant="danger" >
                                        <i className="fas fa-times" style={{ fontSize: '16px', color: '#b83333' }} aria-hidden="true"></i>
                                    </Button>
                                </span>
                            </>
                        ) : (
                            'Click Here To Upload File'
                        )}
                        <p>Files Supported: PDF, DOC, DOCX.</p>
                    </label>

                    <input
                        id="file-upload"
                        type="file"
                        accept=".pdf, .doc, .docx"
                        onChange={handleFileUpload}
                        className="file-upload-input"
                    />
                </div>
            </Col>


            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack}>Back</Button>
                    <Button className="btn-lg btn-shadow" variant="success" onClick={() => handleNext(formData)}>Next</Button>
                </Col>
            </Row>
        </Row>
    );
}

export default StepFive;
